import { types } from 'mobx-state-tree'

export enum DocumentType {
  poi = 'Proof of Identification',
  poa = 'Proof of Address',
  pob = 'Proof of Business',
  pof = 'Proof of Finance',
  cc = 'Cancelled Cheque',
  photo = 'photo',
}

const Document = types.model('Document', {
  id: types.string,
  uid: types.string, // user / merchant id
  type: types.enumeration(Object.values(DocumentType)),
  data: types.string, // path of file or blob data
})

const documentV2 = Document.create({
  id: '1',
  uid: '',
  type: DocumentType.photo,
  data: '',
})

export { Document, documentV2 }
